<template>
  <div class="flsa-submission-timeline d-flex flex-column w-100">
    <FlsaSubmissionTimelineItem
      v-for="(item, index) in sortedSubmissions"
      :key="item.ulid"
      :submission="item"
      :is-first="index === 0"
      :is-last="index === sortedSubmissions.length - 1"
      :show-jurisdiction-pill="showJurisdictionPill && index === 0"
      :show-current-version-badge="showCurrentVersionBadge && index === 0"
      :is-selected="Boolean(props.currentSubmissionUlid && item.ulid === props.currentSubmissionUlid)"
      @click="handleItemClick"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import FlsaSubmissionTimelineItem from '@/components/jobProfiles/editor/FlsaSubmissionTimelineItem.vue';
import { sortSubmissionsByDateDesc } from '@/helpers/flsa';

const props = defineProps({
  submissions: {
    type: Array,
    default: () => [],
  },
  currentSubmissionUlid: {
    type: String,
    default: null,
  },
  showJurisdictionPill: {
    type: Boolean,
    default: false,
  },
  showCurrentVersionBadge: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['submission-click']);

const sortedSubmissions = computed(() => sortSubmissionsByDateDesc(props.submissions));

const handleItemClick = (submission) => {
  emit('submission-click', submission);
};
</script>
